
export const UCBaseLayerSwitchEvent =
{   

    UCBaseLayerSwitch_vector_click: "event_UCBaseLayerSwitch_vector_click",

    UCBaseLayerSwitch_image_click: "event_UCBaseLayerSwitch_image_click",

    UCBaseLayerSwitch_ter_click: "event_UCBaseLayerSwitch_ter_click"


}